/* Femieko Medical — standalone page interactions (mobile menu + partner signup form) */
(function () {
  'use strict';

  // Mobile navigation toggle
  var menu = document.querySelector('.menu');
  var nav = document.querySelector('header nav');
  if (menu && nav) {
    menu.addEventListener('click', function () {
      var open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', open);
      menu.setAttribute('aria-label', open ? 'Închide meniul' : 'Deschide meniul');
      nav.classList.toggle('open', open);
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('open');
        menu.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-label', 'Deschide meniul');
      }
    });
  }

  // Partner signup form -> prefill a Google Form (entry.<name>=<value>)
  var form = document.querySelector('#signup-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var base = form.getAttribute('data-google-form') || '';
      if (!base) return;
      var url;
      try { url = new URL(base); } catch (err) { return; }
      url.searchParams.set('usp', 'pp_url');
      new FormData(form).forEach(function (value, key) {
        if (/^\d+$/.test(key)) url.searchParams.set('entry.' + key, String(value).trim());
      });
      window.location.assign(url.toString());
    });
  }
})();
